import React from 'react';
import { useImageControls } from '../useImageControls';
import { ImageControls } from '../ImageControls';
import { useRefFinally } from '../../../../../utils/useRefFinally';
import { LayersData } from './layerTool';

export const ImageResizer: React.FC<{
  layersData: LayersData;
}> = ({ layersData, children }) => {
  const realDimensions = {
    width: layersData.original_image.size[0],
    height: layersData.original_image.size[1],
  };

  const [refCallback, refObject] = useRefFinally<HTMLDivElement>();
  const imageController = useImageControls(true, refObject, false, realDimensions);

  return (
    <div className="gen-file-viewer__image-container gen-file-viewer__container" ref={refCallback}>
      <div
        onMouseDown={imageController.dragOnMouseDown}
        style={{ transform: imageController.cssTransform }}
      >
        {children}
      </div>
      <ImageControls controller={imageController} />
    </div>
  );
};
